<template lang="pug">
    .component-create-entity-button
        router-link.fa-stack.fa-lg(v-if="item.path !== 'merge'" :to="item.path")
            i.fa.fa-circle.fa-stack-2x
            i.fa.fa-plus.fa-stack-1x.fa-inverse

        router-link.fa-stack.fa-lg(v-if="item.path === 'merge'" :to="item.path")
            i.fa.fa-circle.fa-stack-2x
            i.fa.fa-gear.fa-stack-1x.fa-inverse
</template>
<script type="text/babel">
    export default{
        name: "CreateEntityButton",
        components: {},
        data(){
            return {}
        },
        created() {
        },
        methods: {},
        props: ['item']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateEntityButton.vue?15e60074